import BaseStrapiCollection from "../base-strapi-collection/base-strapi-collection";

export default class TeamNote extends BaseStrapiCollection {
    constructor() {
        super("collectionType", "team-note", "team-notes");
    }
}
